<template>
  <div class="nctouch-main-layout">
    <div class="nctouch-cart-block">
      <!--正在使用的默认地址Begin-->
      <div class="nctouch-cart-add-default" v-if="!isEmpty(addressDefault)"><a href="javascript:void(0);" @click="addressListShow()">
        <dl>
          <dt><span>{{addressDefault.realName}}</span><span>{{addressDefault.mobPhone}}</span><span class="default" v-show="addressDefault.isDefault == 1" data-name="默認">အျမဲသံုး</span></dt>
          <dd style="color: #999"><span>{{addressDefault.areaInfo}} {{addressDefault.address}}</span></dd>
        </dl>
        <i class="icon-arrow"></i></a></div>
      <!--正在使用的默认地址End-->
      <div class="nctouch-cart-no-address" v-else @click="addressListShow()">
        <div class="no-address" data-name="您好，没有地址信息，请添加地址信息">ကုန္လက္ခံလိပ္စာမ်ားကို မထည့္ရေသးသျဖင့္ အသစ္ခုထည့္ပါ။</div>
        <i class="icon-arrow"></i>
      </div>
      <!-- End -->
      <div class="address-adorn"></div>
    </div>
    <!--选择收货地址Begin-->
    <div ref="list-address-wrapper" :class="['nctouch-full-mask', listAddressWrapperClass]">
      <!--<div class="nctouch-full-mask-bg"></div>-->
      <div class="nctouch-full-mask-block">
        <div class="header" id="buyAddressHeader">
          <div class="header-wrap">
            <div class="header-l"> <a href="javascript:void(0);" @click="chooseAddress(addressList[addressListIndex])"> <i class="back"></i> </a> </div>
            <div class="header-title">
              <h1 data-name="收货地址管理">ကုန္လက္ခံလိပ္စာ</h1>
            </div>
          </div>
        </div>
        <div class="nctouch-main-layout address-layout" ref="listAddressScroll" >
          <ul class="nctouch-cart-add-list">
            <li v-for="address in addressList" :class="{selected:addressDefault.addressId == address.addressId}">
              <dl @click="chooseAddress(address)">
                <dt><span class="adr-member-name">{{address.realName}}</span><span class="adr-member-phone">{{address.mobPhone}}</span><span class="default" v-if="address.isDefault == 1">အၿမဲသံုး</span></dt>
                <dd><p>{{address.areaInfo}}</p><p>{{address.address}}</p></dd>
              </dl>
              <!--<div class="address-border"></div>-->
              <div class="address-edit">
                              <span>
                                <a class="edit" href="javascript:;" @click="editAddress(address.addressId)"></a>
                              </span>
              </div>
            </li>

          </ul>
          <div id="buyAddressFoot" class="nctouch-cart-add-btn"> <a href="javascript:void(0);" class="btn mt5"  @click="AddAddress()">လိပ္စာအသစ္သြင္းရန္</a> </div></div>
      </div>
    </div>
    <!--选择收货地址End-->
    <!--新增收货地址Begin-->
    <div id="new-address-wrapper" :class="['nctouch-full-mask', addAddressWrapperClass]">
      <!--<div class="nctouch-full-mask-bg"></div>-->
      <div class="nctouch-full-mask-block">
        <div class="header">
          <div class="header-wrap">
            <div class="header-l"> <a href="javascript:void(0);"  @click="addAddressWrapperClass = 'right'"> <i class="back"></i> </a> </div>
            <div class="header-title">
              <h1 data-name="新增收货地址">ကုန္လက္ခံလိပ္စာအသစ္ထည့္ပါ</h1>
            </div>
          </div>
        </div>
        <div class="nctouch-main-layout">
          <div class="nctouch-inp-con">
            <form>
              <ul class="form-box">
                <li class="form-item">
                  <h4 data-name="收货人">ကုန္လက္ခံ</h4>
                  <div :class="['input-box', {'write' : address.realName.length}]">
                    <input type="text" class="inp" maxlength="10" autocomplete="off" v-model="address.realName" placeholder="အမည္ရိုက္ထည့္ပါ"/>
                    <span class="input-del" @click="address.realName = ''"></span> </div>
                </li>
                <li class="form-item">
                  <h4 data-name="联系手机">ဆက္သြယ္ရန္ဖုန္း</h4>
                  <div :class="['input-box', {'write' : address.mobPhone.length}]">
                    <input type="tel" class="inp" maxlength="15" autocomplete="off" v-model="address.mobPhone" placeholder="ဖုန္းနံပါတ္ရိုက္ထည့္ပါ"/>
                    <span class="input-del" @click="address.mobPhone = ''"></span> </div>
                </li>
                <li class="form-item">
                  <h4 data-name="地区选择">တိုင္း၊ ခရိုင္</h4>
                  <div class="input-box">
                    <input type="text" class="inp" autocomplete="off" v-model="address.areaInfo" @click="areaShow = true" placeholder="လိပ္စာေရြးခ်ယ္ပါ" readonly/>
                  </div>
                </li>
                <li class="form-item">
                  <h4 data-name="详细地址">လိပ္စာအေသးစိတ္</h4>
                  <div :class="['input-box' ,{'write': address.address.length}]">
                    <input type="text" class="inp" maxlength="40" autocomplete="off"  v-model="address.address" placeholder="အေသးစိတ္ရိုက္ထည့္ပါ"/>
                    <span class="input-del" @click="address.address=''"></span> </div>
                </li>
                <li>
                  <h4 data-name="默认地址">အၿမဲသုံးလိပ္စာ</h4>
                  <div class="input-box" style="margin-right:0.55rem">
                    <label :class="[checkBoxValue ? 'checked' : '']">
                      <input type="checkbox" v-model="checkBoxValue"/>
                      <span class="power"></span>
                    </label>
                  </div>
                </li>
              </ul>
              <div class="error-tips"></div>
              <div :class="['form-btn', {'ok' : submitClassOk}]"><a href="javascript:void(0);" @click="addAddressSubmit"  class="btn mt5" data-name="保存">လိပ္စာသိမ္းဆည္းရန္</a></div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--新增收货地址End-->

    <!--编辑收货地址Begin-->
    <div id="edit-address-wrapper" :class="['nctouch-full-mask', editAddressWrapperClass]">
      <!--<div class="nctouch-full-mask-bg"></div>-->
      <div class="nctouch-full-mask-block">
        <div class="header">
          <div class="header-wrap">
            <div class="header-l"> <a href="javascript:void(0);" @click="editAddressWrapperClass = 'right'"> <i class="back"></i> </a> </div>
            <div class="header-title">
              <h1 data-name="编辑收货地址">လိပ္စာအသစ္သြင္းရန္</h1>
            </div>
          </div>
        </div>
        <div class="nctouch-main-layout bgc-w">
          <div class="nctouch-inp-con">
            <form>
              <ul class="form-box">
                <li class="form-item">
                  <h4 data-name="收货人">ကုန္လက္ခံ</h4>
                  <div :class="['input-box', {'write' : address.realName.length}]">
                    <input type="text" class="inp" maxlength="10" autocomplete="off" v-model="address.realName" placeholder="အမည္ရိုက္ထည့္ပါ"/>
                    <span class="input-del" @click="address.realName = ''"></span> </div>
                </li>
                <li class="form-item">
                  <h4 data-name="联系手机">ဆက္သြယ္ရန္ဖုန္း</h4>
                  <div :class="['input-box', {'write' : address.mobPhone.length}]">
                    <input type="tel" class="inp" maxlength="15" autocomplete="off" v-model="address.mobPhone" placeholder="ဖုန္းနံပါတ္ရိုက္ထည့္ပါ"/>
                    <span class="input-del" @click="address.mobPhone = ''"></span> </div>
                </li>
                <li class="form-item">
                  <h4 data-name="地区选择">တိုင္း၊ ခရိုင္</h4>
                  <div class="input-box">
                    <input type="text" class="inp" autocomplete="off" v-model="address.areaInfo" @click="areaShow = true" placeholder="လိပ္စာေရြးခ်ယ္ပါ" readonly/>
                  </div>
                </li>
                <li class="form-item">
                  <h4 data-name="详细地址">လိပ္စာအေသးစိတ္</h4>
                  <div :class="['input-box' ,{'write': address.address.length}]">
                    <input type="text" class="inp" maxlength="40" autocomplete="off"  v-model="address.address" placeholder="အေသးစိတ္ရိုက္ထည့္ပါ"/>
                    <span class="input-del" @click="address.address=''"></span> </div>
                </li>
                <li>
                  <h4 data-name="默认地址">အၿမဲသုံးလိပ္စာ</h4>
                  <div class="input-box" style="margin-right:0.55rem">
                    <label :class="[checkBoxValue ? 'checked' : '']">
                      <input type="checkbox" v-model="checkBoxValue"/>
                      <span class="power"></span>
                    </label>
                  </div>
                </li>
              </ul>
              <div class="error-tips"></div>
              <div :class="['form-btn', {'ok' : submitClassOk}]"><a href="javascript:void(0);" @click="editAddressSubmit" class="btn mt5" data-name="保存">လိပ္စာသိမ္းဆည္းရန္</a></div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--编辑收货地址End-->

    <!--地区选择Begin-->
    <transition name="ncbottom">
      <div class="nctouch-bottom-mask mask-show" v-if="areaShow" ref="layer">
        <div class="nctouch-bottom-mask-bg" @click="areaShow  = false " @touchmove="excludeTouch"></div>
        <div class="nctouch-bottom-mask-block">
          <div class="nctouch-bottom-mask-top" @touchmove="excludeTouch">
            <div class="close">
              <i class="closed" @click="areaShow = false"></i>
              <!--<i @click="areaShow = false;" class="right" v-show="areaShow" data-name="所在地區"></i>-->
              လိပ္စာေရြးခ်ယ္
            </div>
          </div>
          <div class="city-options">
            <div class="city-content">
              <dl class="city-select">
                <dd
                  v-for="(navItem ,navIndex)  in areaNavArray"
                  :class="{select:navIndex ==currentAreaIndex }"
                  @click="bindAreaNavSelect(navIndex)">{{navItem.areaName2}}
                </dd>
              </dl>
              <div class="city-select-panel" ref='swipe'>
                <ul :style="{width: width * areaContentArray.length + 'px'}">
                  <li v-for="(cItem , cIndex) in areaContentArray" :style="{width: width + 'px'}">
                    <div class="city-item-scroll" :id="'cityItem_' + cIndex">
                      <dl class="city-item" >
                        <a href="javascript:;"
                           v-for="areaItem in  cItem"
                           @click="bindAreaSelect(areaItem,cIndex)"
                           :class="{checked:currentAreaInfo &&  currentAreaInfo.areaId==areaItem.areaId}">
                          <h4>{{areaItem.areaName}}</h4><i></i></a>
                      </dl>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- End -->
        </div>
      </div>
    </transition>
    <!--地区选择End-->
  </div>
</template>
<script>
  //    var ApiUrl = "https://my.zegobird.com:11101/api";

  //地区获取接口
  var urlAreaList = ApiUrl + '/area/list';
  var mySwipe, myIScroll ,
    iscrollArray = []
  ;
  // js 区域


  export default {
    //外部传入参数
    props: {
      addressDefault: {}
    },
    /*
     * 自身数据,一定要一个function
     */
    data:function() {
      return {
        listAddressWrapperClass : 'hide',
        editAddressWrapperClass : 'hide',
        addAddressWrapperClass : 'hide',
        addressList : [],
        addressListIndex : 0,
        scrollInstance: null,
        address : {
          isDefault: 0,
          realName : '',
          mobPhone : '',
          areaInfo : '',
          address : ''
        },

        areaShow : false,
        //地区选择导航数组
        areaNavArray: [{
          areaName: "ေျရးခ္ယၸါ",//请选择
          areaName2:"တိုင္း",
          areaId: 0
        }],
        //地区列表数组
        areaContentArray: [],
        //当前选择的地区层级
        currentAreaIndex: 0,
        submitSign : false
      }
    },
    /**
     * 计算属性
     */
    computed: {
      width:function(){
        return $(window).width()
      } ,
      checkBoxValue : {
        get:function(){
          return this.address.isDefault ? true : false
        },
        set :function (value) {
          this.address.isDefault = value ? 1 : 0
        }
      },
      //当前地区选择信息
      currentAreaInfo: function () {
        return this.areaNavArray[this.currentAreaIndex]
      },
      submitClassOk : function() {
        return this.address.realName.length && this.address.mobPhone.length && this.address.areaInfo.length && this.address.address.length;
      }
    },

    /**
     * 监听属性变动
     */
    watch: {
      //监控是否地区选择
      areaShow: function (newValue) {
        if (newValue) {
          this.initArea()
        }
      }
    },
    /**
     * 过滤器
     */
    filters: {

    },
    /**
     * 生命周期钩子
     */

    beforeCreate:function() {

    },
    created:function() {
      console.log("buyAddress -> created:")
    },

    beforeMount:function() {

    },
    mounted:function() {
      console.log("buyAddress -> mounted")

    },
    beforeUpdate:function() {

    },
    updated:function() {
      console.log("buyAddress -> updated")
    },
    beforeDestroy:function() {

    },
    destroy() {

    },
    mounted:function(){
    },
    /**
     * 自定义方法
     */
    methods: {
      //去除无关的touch事件
      excludeTouch:function(event){
        event.preventDefault();
        return false ;
      },
      isEmpty : function(value) {
        return Nc.isEmpty(value);
      },
      addressListShow : function() {
        var self = this;
        $.post(ApiUrl + "/member/address/list", {
          token : getMemberToken()
        }, function(xhr){
          var str = JSON.stringify(xhr);
          var my = Rabbit.uni2zg(str);
          xhr = JSON.parse(my);
          if (xhr.code == 200) {
            self.addressList = xhr.datas.addressList;
            for(var i in self.addressList) {
              if (!Nc.isEmpty(self.addressDefault) && self.addressDefault.addressId == self.addressList[i].addressId) {
                self.addressListIndex = i;
              }
            }
            self.listAddressWrapperClass = "left";

            self.$nextTick(function () {
              if (!self.scrollInstance) {
                self.scrollInstance = new IScroll(self.$refs.listAddressScroll, {
                  scrollX: true,
                  scrollY: true,
                  click: true
                });
              } else {
                self.scrollInstance.refresh()
              }
            })
          }
        });
      },
      // 编辑收货地址
      editAddress : function(addressId) {
        var self = this;
        $.ajax({
          type: 'post',
          url: ApiUrl + '/member/address/info',
          data: {
            token: getMemberToken(),
            addressId: addressId
          },
          dataType: 'json',
          success: function(xhr) {
            var str = JSON.stringify(xhr);
            var my = Rabbit.uni2zg(str);
            xhr = JSON.parse(my);
            self.address = xhr.datas.address
            self.address.mobPhone = Nc.isEmpty(self.address.mobPhone) ? '' : self.address.mobPhone;
            self.editAddressWrapperClass = "left"
          }
        });
      },
      // 编辑收货地址提交
      editAddressSubmit : function() {
        var self = this;
        if (self.submitClassOk == false) {
          return;
        }
        if (!(/^09\d{7,9}$/.test(this.address.mobPhone))) {
          alertError("ဖုန္းနံပါတ္ကို ႐ိုက္ထည့္ေပးပါ");//请填写正确的联系手机
          return;
        }
        var params = $.extend({token : getMemberToken()},this.address);
        $.ajax({
          type: 'post',
          url: ApiUrl + "/member/address/edit",
          data: params,
          dataType: 'json',
          success: function(result) {
            var str = JSON.stringify(result);
            var my = Rabbit.uni2zg(str);
            result = JSON.parse(my);
            if (result.code==200) {
              self.editAddressWrapperClass = "right";
              self.chooseAddress(params);
            } else {
              alertError(result.datas.error);
            }
          }
        });
      },
      // 新增收货地址
      AddAddress : function() {
        this.address.isDefault = 0;
        this.address.realName = '';
        this.address.mobPhone = '';
        this.address.areaId1 = 0;
        this.address.areaId2 = 0;
        this.address.areaId3 = 0;
        this.address.areaId4 = 0;
        this.address.areaId = 0;
        this.address.areaInfo = '';
        this.address.address = '';
        this.addAddressWrapperClass = "left"
      },
      // 新增收货地址提交
      addAddressSubmit : function() {
        var self = this;
        if (self.submitClassOk == false || self.submitSign == true) {
          return;
        }
        if (!(/^09\d{7,9}$/.test(this.address.mobPhone))) {
          alertError("ဖုန္းနံပါတ္ကို ႐ိုက္ထည့္ေပးပါ");//请填写正确的联系手机
          return;
        }
        self.submitSign = true;
        var params = $.extend({token : getMemberToken()},this.address);
        $.ajax({
          type: 'post',
          url: ApiUrl + "/member/address/add",
          data: params,
          dataType: 'json',
          success: function(result) {
            var str = JSON.stringify(result);
            var my = Rabbit.uni2zg(str);
            result = JSON.parse(my);
            if (result.code==200) {
              self.addAddressWrapperClass = "right";
              params.addressId = result.datas.addressId;
              self.chooseAddress(params);
            } else {
              alertError(result.datas.error);
            }
          }
        });
      },

      //初始化地区
      initArea: function () {
        var self = this
        $.get(urlAreaList, {
          areaId: 0
        }, function (xhr) {
          if (xhr.code == 200) {
            var str = JSON.stringify(xhr);
            var my = Rabbit.uni2zg(str);
            xhr = JSON.parse(my);
            self.currentAreaIndex = 0;
            self.areaNavArray.splice(0, self.areaNavArray.length, {
              areaName2: "တိုင္း",//省
              areaId: 0
            });
            self.areaContentArray.splice(0, self.areaContentArray.length, xhr.datas.areaList)
            self.setupSwipe()
            self.slideToSwipe(0)
          }
        })
      },
      //获取地区列表
      loadAreaList: function (areaId) {
        var self = this;
        $.get(urlAreaList, {
          areaId: areaId
        }, function (xhr) {
          if (xhr.code == 200) {
            var str = JSON.stringify(xhr);
            var my = Rabbit.uni2zg(str);
            xhr = JSON.parse(my);
            // self.areaNavArray.push({
            //   areaName: "ေျရးခ္ယၸါ",//请选择
            //   areaId: 0
            // });
            self.areaContentArray.push(xhr.datas.areaList)
            self.setupSwipe()
            self.slideToSwipe(self.currentAreaIndex)
          } else {
            //地区选择完成
            self.areaSelectEnd();
          }
        })
      },
      //地区选择结束
      areaSelectEnd: function () {
        this.address.areaId1 = this.areaNavArray.length >=1 && this.areaNavArray[0].areaId ? this.areaNavArray[0].areaId : 0;
        this.address.areaId2 = this.areaNavArray.length >=2 && this.areaNavArray[1].areaId ? this.areaNavArray[1].areaId : 0;
        this.address.areaId3 = this.areaNavArray.length >=3 && this.areaNavArray[2].areaId ? this.areaNavArray[2].areaId : 0;
        this.address.areaId4 = this.areaNavArray.length >=4 && this.areaNavArray[3].areaId ? this.areaNavArray[3].areaId : 0;
        this.address.areaInfo = $.map(this.areaNavArray, function(n){
          return n.areaName;
        }).join(" ");
        // 这个放最后
        this.address.areaId = this.areaNavArray.pop().areaId;
        this.areaShow = false;
      },
      //手动刷新swipe
      setupSwipe: function () {
        var self = this
        this.$nextTick(function () {
          if (mySwipe){
            mySwipe.destroy()
          }
          mySwipe = new IScroll(this.$refs.swipe, {
            scrollX: true,
            scrollY: false,
            momentum: false,
            snap: true,
            snapSpeed: 400,
            click: false,
            bounce: false,
            excludeElement: "scroll-exclude",
            snapCallBack: function (pageX, pageY) {
              self.currentAreaIndex = pageX
            }
          });
        })
      },
      //地区swipe滚动到
      slideToSwipe: function (index ,retain) {
        this.$nextTick(function () {

          mySwipe.goToPage(index,0)

          if (retain) return
          if (iscrollArray[index]){
            iscrollArray[index].destroy();
          }
          iscrollArray[index] = new IScroll("#cityItem_" + index, {
            scrollX: false,
            scrollY: true,
            click: true
          });

        })
      },
      //地区列表中的地区选择
      bindAreaSelect: function (areaInfo, index) {
        // if (this.currentAreaInfo && this.currentAreaInfo.areaId == areaInfo.areaId) return;

        this.currentAreaIndex = index + 1
        if(this.currentAreaIndex==1){
          this.areaNavArray.splice(index, this.areaNavArray.length, {
            areaName: areaInfo.areaName,
            areaName2:"တိုင္း",
            areaId: areaInfo.areaId
          })
          this.areaNavArray.push({
            areaName2:"ခရိုင္"
          })
        }
        else if(this.currentAreaIndex==2){
          this.areaNavArray.splice(index, this.areaNavArray.length, {
            areaName: areaInfo.areaName,
            areaName2:"ခရိုင္",
            areaId: areaInfo.areaId
          })
          this.areaNavArray.push({
            areaName2:"ၿမိဳ႕နယ္"
          })
        }
        else if(this.currentAreaIndex==3){
          this.areaNavArray.splice(index, this.areaNavArray.length, {
            areaName: areaInfo.areaName,
            areaName2:"ၿမိဳ႕နယ္",
            areaId: areaInfo.areaId
          })
          this.areaNavArray.push({
            areaName2:"ၿမိဳ႕"
          })
        }
        else if(this.currentAreaIndex==4){
          this.areaNavArray.splice(index, this.areaNavArray.length, {
            areaName: areaInfo.areaName,
            areaName2:"ၿမိဳ႕",
            areaId: areaInfo.areaId
          })

        }
        // this.areaNavArray.splice(index, this.areaNavArray.length, {
        //   areaName: areaInfo.areaName,
        //   areaId: areaInfo.areaId
        // })
        this.areaContentArray.splice(index + 1)
        this.loadAreaList(areaInfo.areaId)
      },
      //地区导航点击
      bindAreaNavSelect: function (navIndex) {
        this.currentAreaIndex = navIndex
        this.slideToSwipe(navIndex , true )
      },

      // 选择地址
      chooseAddress : function(address) {
        console.log("emit -> choose-address")
        this.listAddressWrapperClass = 'right';
        this.$emit('choose-address', address);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/buy-address/buy-address.vue